<ion-header class="main-fixed-header" [scrollHide]="headerScrollConfig" [scrollContent]="eventSearchContent"
  style="top: -110px" *ngIf="!clientSpecific">
  <div>
    <ion-toolbar id="#eventMainSearchbar">
      <ion-buttons slot="start">
        <ion-button fill="clear" color="primary" (click)="scrollIntoView(searchform)">
          <ion-icon slot="icon-only" name="funnel-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        {{ 'GLOBAL_SEARCH_RESULTS' | translate }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" color="primary" (click)="openMap()" [attr.aria-label]="'GLOBAL_MAPS' | translate">
          <ion-icon name="map-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>
</ion-header>

<ion-content #eventSearchContent id="eventSearchContent" fullscreen (ionScroll)="onScroll($event)" >
  <div #searchform class="events-main-bg-image" [class.fullscreen]="!clientSpecific">
    <span class="events-main-animation-prefix"></span>
    <span class="events-main-color-prefix" *ngIf="picLayout"></span>
    <span class="events-main-color-prefix-simple" *ngIf="!picLayout"></span>

    <ion-row *ngIf="(((SECOND_LAYER || THIRD_LAYER) && !searched) || (SEARCH_LAYER && !clientSpecific)) && !openDetails"
      class="margin-bottom-negative">
      <ion-col class="ion-text-start" class="col-flex">
        <!-- <ion-icon padding-left name="arrow-back"></ion-icon> -->
        <!-- <button ion-button clear color="light" no-padding (click)="onBackMenu()">
          <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </button> -->
        <ion-button fill="clear" color="light" (click)="onBackMenu()" class="ion-align-items-center">
          <ion-icon name="arrow-back" slot="start" class="ion-padding-start"></ion-icon>
          <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row [ngStyle]="{'margin-top': appDetector.isForestApp() ? '40px' : '20px'}" class="ion-padding-horizontal ion-statusbar-padding" *ngIf="!searched || appDetector.isForestApp()" 
      class="events-main-header events-main-header-overlay">
        <ion-col  size="8" class="ion-text-start" >
          <h1 class="ion-text-bold" *ngIf="!clientSpecific">{{ 'MAIN_TAB_TITLE_EVENTSEARCH' | translate }}</h1>
          <!-- <button *ngIf="(spooortsApp || hellaClient) && openDetails" ion-button clear color="light" no-padding
            (click)="onSecondBackMenu()">
            <strong>&#60; {{ 'GLOBAL_BACK' | translate }}</strong>
          </button> -->
          <ion-button fill="clear" color="light" class="ion-align-items-center ion-no-padding"
          *ngIf="(spooortsApp || hellaClient) && openDetails" (click)="onSecondBackMenu()">
            <ion-icon name="arrow-back" slot="start" class="ion-padding-start"></ion-icon>
            <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </ion-button>
          <!-- <h1 text-bold *ngIf="clientSpecific">{{'MAIN_TAB_TITLE_EVENTS' | translate}}</h1> -->
        </ion-col>
        <ion-col size="4" class="ion-text-end" *ngIf="isAccountAllowed && !appDetector.isForestApp()">
          <ion-button fill="clear" color="light" *ngIf="showMySport" (click)="showLogin()"
            [attr.aria-label]="'GLOBAL_MYSPORT' | translate" shape="round" >
          <!-- <button ion-button icon-only clear color="light" (click)="showLogin()" *ngIf="showMySport"
            attr.aria-label="{{ 'GLOBAL_MYSPORT' | translate }}"> -->
            <span [style.background-image]="'url(' + profileImage() + ')'" class="user-image-m" *ngIf="isLoged()"
              circle></span>
            <span [style.background-image]="'url(/assets/imgs/default-image-32@1x.png)'" class="user-image-m"
              *ngIf="!isLoged()" circle></span>
          </ion-button>
        </ion-col>
    </ion-row>
    <ion-row>

    </ion-row>
    <div class="events-main-content" *ngIf="!clientSpecific && !searched">
      <div class="events-main-content-inner ion-padding">

        <div *ngIf="spooortsApp && newMenu && SEARCH_LAYER"
          class="events-main-content event-main-countdown custom-spooorts-countdown">
          <div class="countdown-container">
            <span class="countdown-snippet">
              <span class="countdown-card">{{ getEventDay() }}</span>
              <span class="countdown-text">{{ 'GLOBAL_DAYS' | translate }}</span>
            </span>
            <span class="countdown-snippet">
              <span class="countdown-card">{{ getEventHour() }}</span>
              <span class="countdown-text">{{ 'GLOBAL_HOURS' | translate }}</span>
            </span>
            <span class="countdown-snippet">
              <span class="countdown-card">{{ getEventMin() }}</span>
              <span class="countdown-text">{{ 'GLOBAL_MINUTES' | translate }}</span>
            </span>
            <span class="countdown-snippet">
              <span class="countdown-card">{{ getEventSec() }}</span>
              <span class="countdown-text">{{ 'GLOBAL_SECONDS' | translate }}</span>
            </span>
          </div>
        </div>
        <!-- for hella app we disable all padding and margin -->

        <ion-row *ngIf="!(spooortsApp && newMenu && SEARCH_LAYER)">
          <ion-col size="6">
            <ion-row class="custom-search-field">
              <ion-col size="2">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <mysport-icon [cid]="searchModel.cid" color="light" size="small"></mysport-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="10" class="custom-search-field-container">
                <!-- <ion-item class="custom-search-field-container"> -->
                  <ion-label class="sr-only">
                    {{ 'EVENT_CATEGORY' | translate }}
                  </ion-label>
                  <ion-select class="select-elem" [(ngModel)]="activeSportType" [placeholder]="activeSportType?.name" (ionChange)="onSportTypeChange($event)"
                    cancelText="{{ 'GLOBAL_CANCEL' | translate }}" okText="{{ 'GLOBAL_OK' | translate }}"
                  >
                    <ion-select-option *ngFor="let eventCategory of sportTypes" [value]="eventCategory"
                    >
                      {{ eventCategory.name | translate }}
                    </ion-select-option>
                  </ion-select>
                <!-- </ion-item> -->
              </ion-col>
            </ion-row>
          </ion-col>
          <!-- <ion-col col-6> -->
            <!-- <ion-row class="custom-search-field">
              <ion-col col-2>
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner" text-center>
                    <ion-icon color="white" name="locate" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col col-10 ion-item class="custom-search-field-container">
                <ion-label class="sr-only">{{ 'EVENT_RANGE' | translate }}</ion-label>
                <ion-select [(ngModel)]="searchModel.umkr" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                  okText="{{ 'GLOBAL_OK' | translate }}">
                  <ion-option *ngFor="let range of eventRanges" [value]="range.ident">{{ range.ident }}</ion-option>
                </ion-select>
              </ion-col>
            </ion-row> -->
          <!-- </ion-col> -->
          <!-- <ion-col col-6>
            <ion-row class="custom-search-field">
              <ion-col col-2>
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner" text-center>
                    <ion-icon color="white" name="resize" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col col-10 ion-item class="custom-search-field-container">
                <ion-label class="sr-only">{{ 'EVENT_DISTANCE' | translate }}</ion-label>
                <ion-select [(ngModel)]="searchModel.str" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                  okText="{{ 'GLOBAL_OK' | translate }}">
                  <ion-option *ngFor="let distance of eventDistances" [value]="distance.ident">{{ distance.ident }}
                  </ion-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col> -->
          <ion-col size="6">
            <ion-row class="custom-search-field">
              <ion-col size="2">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon name="calendar" class="sportart-icon-big" color="light"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="10" class="custom-search-field-container">
                  <ion-label class="sr-only">{{ 'EVENT_DATE' | translate }}</ion-label>
                  <ion-select [(ngModel)]="searchModel.dur"
                              cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                              okText="{{ 'GLOBAL_OK' | translate }}"
                              class="select-elem">
                    <ion-select-option *ngFor="let date of eventDates" [value]="date.ident">
                      {{ date.ident | translate}}
                    </ion-select-option>
                  </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
          <!-- <ion-col col-6>
            <ion-row class="custom-search-field">
              <ion-col col-2>
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner" text-center>
                    <ion-icon color="white" name="calendar" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col col-10 ion-item class="custom-search-field-container">
                <ion-label class="sr-only">{{ 'EVENT_DATE' | translate }}</ion-label>
                <ion-select [(ngModel)]="searchModel.dur" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                  okText="{{ 'GLOBAL_OK' | translate }}">
                  <ion-option *ngFor="let date of eventDates" [value]="date.ident">{{ date.ident }}</ion-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col> -->
        </ion-row>

        <ion-row *ngIf="!(spooortsApp && newMenu && SEARCH_LAYER)">
          <ion-col size="12">
            <ion-item class="custom-search-field no-border custom-search-text">
              <ion-icon name="flag" slot="start" color="medium"></ion-icon>
              <ion-input type="text" maxlength="25" pattern="^[A-Za-z\\s'\\-]+$" [(ngModel)]="searchModel.searchQuery" placeholder="{{ 'GLOBAL_ZIP' | translate }}" (keyup)="updateZip($event)">
              </ion-input>
            </ion-item>
            <!-- Optional label -->
            <!--
            <ion-label *ngIf="!isBrowser" class="ion-text-end" color="light">
              <ion-icon name="pin" class="ion-margin-end"></ion-icon> {{ city }}
            </ion-label>
            -->
          </ion-col>
        </ion-row>
        <ion-row *ngIf="!(spooortsApp && newMenu && SEARCH_LAYER)">
          <ion-col size="12" class="ion-text-center">
            <ion-button color="light" fill="outline" (click)="onSearch(resultList)">
              <ion-icon name="search" slot="start"></ion-icon>
              {{ 'GLOBAL_SEARCH' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>
        <!-- <button ion-fab (click)="showAddEvent()">
          <ion-icon name="add"></ion-icon>
        </button>-->
      </div>
    </div>

    <!-- <div [ngClass]="{'black-font': postbonnClient}" class="events-main-content event-main-countdown" -->

    <div [ngClass]="{'black-font': postbonnClient}" class="events-main-content event-main-countdown"
      *ngIf="clientSpecific && clientNextEvent != null">

      <div class="ion-padding ion-text-center events-main-content-inner events-main-content-inner-margin-top">
        <h1 padding-bottom style="margin-top: 2px;" *ngIf="!vivawestClient && !hellaClient">
          {{ 'GLOBAL_WELCOME' | translate }}!</h1>
        <h1 padding-bottom style="margin-top: 50px;font-size: 2.0rem;" *ngIf="vivawestClient">VIVAWEST-Marathon Virtual
          Run 2020</h1>
        <h1 padding-bottom style="font-size: 2.0rem;" *ngIf="postbonnClient">Deutsche Post Marathon Bonn
          <br />
          Virtual BTHVN Run 2020
        </h1>
        <div margin-top *ngIf="hellaClient">
          <span class="countdown-text small-text">{{ 'NEXT_EVENT_TEXT' | translate}}</span>
          <p class="main-next-event">
            {{ clientNextEvent.name }}
          </p>
        </div>
        <p color="white" *ngIf="vivawestClient">{{ 'GLOBAL_CLIENT_VIVAWEST_WELCOME' | translate: clientNextEvent }}
        </p>


        <!-- OPEN - FOREST/SPOOORTS APP -->
        <div class="margin-bottom-top" *ngIf="spooortsApp">
          <span class="countdown-snippet">
            <span class="countdown-text">{{ 'GLOBAL_PFLANZEN_MESSAGE' | translate }}</span>
          </span>
        </div>

        <div *ngIf="spooortsApp && updater" class="countdown-container">
          <span class="countdown-snippet">
            <span class="countdown-card">{{ treesCounter.millions }}</span>
            <span class="countdown-text">{{ 'GLOBAL_MILLIONS' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card">{{ treesCounter.thousands }}</span>
            <span class="countdown-text">{{ 'GLOBAL_THOUSAND' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card">{{ treesCounter.hundreds }}</span>
            <span class="countdown-text">{{ 'GLOBAL_TREES' | translate }}</span>
          </span>
        </div>
        <!-- CLOSE - FOREST/SPOOORTS APP -->

        <!-- for hella app we disable all padding and margin -->
        <div *ngIf="!hellaClient && updater && !spooortsApp" class=" mb-4 pb-4 countdown-container">
          <span class="countdown-snippet">
            <span class="countdown-card" [ngStyle]="{ 'color' : appDetector.isHannoverApp()? 'black' : 'map-get($colors, primary)'}">{{ getEventDay() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_DAYS' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card" [ngStyle]="{ 'color' : appDetector.isHannoverApp()? 'black' : 'map-get($colors, primary)'}">{{ getEventHour() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_HOURS' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card" [ngStyle]="{ 'color' : appDetector.isHannoverApp()? 'black' : 'map-get($colors, primary)'}">{{ getEventMin() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_MINUTES' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card" [ngStyle]="{ 'color' : appDetector.isHannoverApp()? 'black' : 'map-get($colors, primary)'}">{{ getEventSec() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_SECONDS' | translate }}</span>
          </span>
        </div>

        <div *ngIf="hellaClient && updater" class="countdown-container">
          <span class="countdown-snippet">
            <span class="countdown-card">{{ getEventDay() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_DAYS' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card">{{ getEventHour() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_HOURS' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card">{{ getEventMin() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_MINUTES' | translate }}</span>
          </span>
          <span class="countdown-snippet">
            <span class="countdown-card">{{ getEventSec() }}</span>
            <span class="countdown-text">{{ 'GLOBAL_SECONDS' | translate }}</span>
          </span>
        </div>

        <ion-button color="primary" (click)="openTracking()" *ngIf="buttonMainGPS">
          <ion-icon slot="start" name="navigate"></ion-icon>
          {{ 'EVENT_SEARCH_COUNTDOWN_BUTTON' | translate }}
        </ion-button>
      </div>
    </div>
    <div class="events-main-content event-main-countdown" *ngIf="clientSpecific && clientNextEvent == null">
      <div class="events-main-content-inner ion-padding ion-text-center">
        <h1 class="ion-padding-bottom">{{ 'GLOBAL_WELCOME' | translate }}!</h1>
      </div>
    </div>
  </div>

  <ion-list id="resultList" #resultList *ngIf="(events.length !== 0 && searched) && SEARCH_LAYER" >
    <ion-item-divider color="light" *ngIf="!clientSpecific">{{ 'GLOBAL_SEARCH_RESULTS' | translate }}</ion-item-divider>
      <event-search-list-item *ngFor="let event of events; let i = index" [event]="event" [openDetails]="appDetector.isEventsApp() ? true : openDetails"
        [pipeDateFormat]="pipeDateFormat" [order]="i" (onEvent)="onSecondLayerPressed($event)">
      </event-search-list-item>
      <ion-infinite-scroll (ionInfinite)="loadNextPage($event)" *ngIf="events.length % 10 === 0 && events.length !== 0">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
          loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
  </ion-list>

  <!-- First layer for events app -->
  <!-- <ion-list *ngIf="newMenu && !searched && FIRST_LAYER && !openDetails">
    <div *ngFor="let complex of getEventComplex(); index as i; first as isFirst">
      <ion-item-divider class="list-header" color="light">
        <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ complex.category }}.png'>
        <span>{{ complex.category | translate | uppercase }}</span>
      </ion-item-divider>
      <ion-item class="list-item button-flex" *ngFor="let event of getAllEvents(i)"
        (click)="onSecondLayerForward(event)">
        <ion-avatar item-start>
          <img src="{{event.imgPath}}">
        </ion-avatar>
        <ion-row>
          <h4 text-nowrap>{{ event.eventName }}</h4>
        </ion-row>
        <ion-row>
          <h4 class="event-date">{{ event.dateFormatted }}</h4>
        </ion-row>
      </ion-item>
      <ion-infinite-scroll (ionInfinite)="loadNextSportsPage($event, i)"
        *ngIf="(getAllEvents(i).length % 10 === 0 && getAllEvents(i).length !== 0) && !appDetector.isEventsApp()">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
          loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
      <ion-item style="text-align: center;" *ngIf="appDetector.isEventsApp()">
        <button ion-button (click)="onMorePress(complex)" *ngIf="!isFirst">
          {{ 'GLOBAL_MORE_EVENTS' | translate | uppercase }}</button>
        <button ion-button (click)="onMoreVirtualEvents(complex)" *ngIf="isFirst">
          {{ 'GLOBAL_MORE_EVENTS' | translate | uppercase }}</button>
      </ion-item>
    </div>
  </ion-list> -->

  <div *ngIf="newMenu && SEARCH_LAYER">
    <event-search-list-item *ngFor="let event of events" [event]="event" [openDetails]="openDetails"
      [pipeDateFormat]="pipeDateFormat" (onEvent)="onSecondLayerPressed($event)">
    </event-search-list-item>
  </div>

  <!-- Second layer for events app -->
  <menu-layer-category eventType="{{ getEventType() }}" (getTotalEvents)="onLoadThirdLayer($event)"
    *ngIf="SECOND_LAYER && !searched">
  </menu-layer-category>

  <events-block-with-containers *ngIf="reload && !searched && appDetector.isEventsApp()"></events-block-with-containers>

  <ion-fab slot="fixed" horizontal="end" vertical="bottom" *ngIf="addNewEvent">
    <ion-fab-button color="primary" (click)="showNewEvent()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- <ion-fab left bottom>
    <button ion-fab color="primary" (click)="onTestPageLoad()">
      <ion-icon name="smile"></ion-icon>
    </button>
  </ion-fab> -->

</ion-content>